import { render, staticRenderFns } from "./PaPlanSelectPage.vue?vue&type=template&id=5255aa92&scoped=true"
import script from "./PaPlanSelectPage.vue?vue&type=script&lang=js"
export * from "./PaPlanSelectPage.vue?vue&type=script&lang=js"
import style0 from "./PaPlanSelectPage.vue?vue&type=style&index=0&id=5255aa92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255aa92",
  null
  
)

export default component.exports